//
// Copyright 2026 DXOS.org
//
import * as Rpc from '@effect/rpc/Rpc';
import * as RpcGroup from '@effect/rpc/RpcGroup';
import * as Context from 'effect/Context';
import * as Schema from 'effect/Schema';
import { protoMessage, serviceError } from './service-rpc.js';
//
// RPC message schemas.
//
export const AcceptInvitationRequest = Schema.Struct({
    invitation: protoMessage('dxos.client.services.Invitation'),
    deviceProfile: Schema.optional(protoMessage('dxos.halo.credentials.DeviceProfileDocument')),
});
export const AuthenticationRequest = Schema.Struct({
    invitationId: Schema.String,
    authCode: Schema.String,
});
export const CancelInvitationRequest = Schema.Struct({
    invitationId: Schema.String,
});
/**
 * Effect RPC definitions for `dxos.client.services.InvitationsService`.
 * Service-only payloads use Effect schemas; shared proto types remain protobuf-encoded on the wire.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('createInvitation', {
    payload: protoMessage('dxos.client.services.Invitation'),
    success: protoMessage('dxos.client.services.Invitation'),
    error: serviceError,
    stream: true,
}), Rpc.make('acceptInvitation', {
    payload: AcceptInvitationRequest,
    success: protoMessage('dxos.client.services.Invitation'),
    error: serviceError,
    stream: true,
}), Rpc.make('authenticate', {
    payload: AuthenticationRequest,
    error: serviceError,
}), Rpc.make('cancelInvitation', {
    payload: CancelInvitationRequest,
    error: serviceError,
}), Rpc.make('queryInvitations', {
    success: protoMessage('dxos.client.services.QueryInvitationsResponse'),
    error: serviceError,
    stream: true,
})).prefix('InvitationsService.') {
}
/**
 * Effect service tag for the `InvitationsService` RPC handlers.
 */
export class Tag extends Context.Tag('@dxos/protocols/rpc/InvitationsService')() {
}
//# sourceMappingURL=InvitationsService.js.map